const fromQueryString = function (key) {
    const parts = window.location.search.substring(1).split('&');
    for (let i = 0; i < parts.length; i++) {
        const pair = parts[i].split('=');
        if (pair[0] == key) {
            return pair[1];
        }
    }
};
export default fromQueryString;
